module.exports = __webpack_public_path__ + "3e2ecc5af7d86d026b371069e5445a11.svg";